import MarketingOptIn from './MarketingOptIn'

export default MarketingOptIn



// WEBPACK FOOTER //
// ./src/containers/MarketingOptIn/MarketingOptIn/index.js